import { rtkQueryApi } from '~/shared/api/rtk-query-api';
import { ILaunchHistoryItem, ILaunchHistoryResponse } from '../types/types';

export const launchHistoryApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getLaunchHistory: builder.query<ILaunchHistoryResponse, { page: number; pageSize: number; search?: string; filters?: any; sort_by?: string; sort_dir?: string }>({
      query: ({ page, pageSize, search, filters, sort_by, sort_dir }) => {
        const params: Record<string, any> = {
          page: page + 1,
          page_size: pageSize,
        };

        if (search) {
          params.search = search;
        }
        if (sort_by) {
          params.sort_by = sort_by;
        }
        if (sort_dir) {
          params.sort_dir = sort_dir;
        }

        if (filters) {
          if (filters.account_name) {
            params.account_name = filters.account_name;
          }
          if (filters.customer_id) {
            params.customer_id = filters.customer_id;
          }
          if (filters.min_launches) {
            params.min_launches = filters.min_launches;
          }
          if (filters.max_launches) {
            params.max_launches = filters.max_launches;
          }
          if (filters.date_from) {
            params.date_from = filters.date_from;
          }
          if (filters.date_to) {
            params.date_to = filters.date_to;
          }
          if (filters.status) {
            params.status = filters.status;
          }
        }

        return {
          url: '/launch-history',
          method: 'GET',
          params,
        };
      },
    }),
    getAccountLaunchHistory: builder.query<ILaunchHistoryItem[], number>({
      query: (accountId) => ({
        url: `/launch-history/account/${accountId}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        if (!response) return [];
        
        // Handle standard format: { data: [...], pagination: {...} }
        if (response.data && Array.isArray(response.data)) {
          return response.data as ILaunchHistoryItem[];
        }
        
        // Handle array response
        if (Array.isArray(response)) return response;
        
        // Handle object with numeric keys format: { "0": {...}, "1": {...}, pagination: {...} }
        const { pagination, ...itemsMap } = response;
        return Object.values(itemsMap) as ILaunchHistoryItem[];
      },
    }),
  }),
});

export const { useGetLaunchHistoryQuery, useGetAccountLaunchHistoryQuery } = launchHistoryApi;
